import { render } from "./PShowPaymentInfo.vue?vue&type=template&id=60b5519a"
import script from "./PShowPaymentInfo.vue?vue&type=script&lang=js"
export * from "./PShowPaymentInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__